<template>
    <div v-if="links.length > 3">
        <div class="flex justify-center flex-wrap">
            <template v-for="(link, p) in links" :key="p">
                <div v-if="link.url === null" class="hidden"
                     v-html="link.label" />
                <admin-link class="!px-6" v-else :class="{ 'bg-red text-white': link.active }" :href="link.url" v-html="link.label" />
            </template>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3';
import AdminLink from "@/Components/Admin/AdminLink";
export default {
    components: {
        Link,
        AdminLink
    },
    props: {
        links: Array
    },
}
</script>
